module.exports = __webpack_public_path__ + "static/img/s166.eb8fc993.png";